import React, {Component} from "react";
import {connect} from "react-redux";

import {loadDataAction, setMapDataAction, startOverMapAction} from "./../../actions/DataAction";

import SubNavTabs from "./../../components/nav/SubNavTabs";
import Introduction from "./../../components/blocks/Introduction";
import EUWideLaborDemand from "../../components/slides/euwide/today/EUWideLaborDemand";
import EUWideEmpRates from "../../components/slides/euwide/today/EUWideEmpRates";
import GeoConcentrationToday from "../../components/slides/euwide/today/GeoConcentrationToday";

import {VIEWS, FILE_KEYS, EMPLOYMENT_FIELDS} from "./../../helpers/consts";

import "./Employment.css";
import JobDelta from "../../components/slides/euwide/outlook/JobDelta";

class Employment extends Component {

  constructor(props) {
    super();
    this.launchDataAction = this.launchDataAction.bind(this);
  }

  componentDidMount() {
    this.props.loadDataAction([FILE_KEYS.EMPLOYMENT_DATA, FILE_KEYS.OCCUPATIONAL_EU], this.props.db);
    this.props.startOverMap();
    this.launchDataAction();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.geojson !== this.props.geojson ||
      prevProps.options.perspective !== this.props.options.perspective ||
      prevProps.options.measure !== this.props.options.measure
      ) {
      this.launchDataAction();
    }
  }

  launchDataAction() {
    const {options} = this.props;
    const fieldSelected = EMPLOYMENT_FIELDS[`${options.perspective.key}_${options.measure.key}`];
    if (fieldSelected){
      this.props.setMapDataAction(VIEWS.EMPLOYMENT, fieldSelected);
    }
  }

  render() {
    return (
      <div id="fow-view-employment">
        <SubNavTabs baseUrl={`/map/${VIEWS.EMPLOYMENT}`}>
          <div>
            <Introduction title="A patchwork of varying outcomes">
              <div className="fow-col fow-col-1 fow-col-count-2 fow-md-col-count-1">
                <p>Beneath the overall European and national employment numbers are many nuanced stories. We have
built an extensive data set covering almost 1,100 local labor markets. The results show that job and
population growth are increasingly concentrated in a small number of dynamic cities—and the gap
between those cities and hundreds of shrinking regions is widening.</p>
                <p>Our research looks at the trends of the past decade, since the starting point in each local economy today
will determine its ability to adapt in the years ahead as more work activities are automated. Then we
take a forward-looking view that combines the potential for displacement, the potential for job growth,
and demographic trends. Together they paint a picture of how the future of work might play out across
Europe after the COVID-19 crisis abates.</p>
              </div>
            </Introduction>
          </div>
          <div>
            <EUWideLaborDemand />
            <EUWideEmpRates />
            <GeoConcentrationToday />
          </div>
          <div>
            <JobDelta mode="decline"/>
            <JobDelta mode="growth"/>
          </div>
        </SubNavTabs>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    geojson: state.db.map.geojsonOptions[VIEWS.EMPLOYMENT],
    db: state.db,
    options: state.settings.switch
  };
};
const mapDispatchToProps = dispatch => ({
  startOverMap: () => dispatch(startOverMapAction()),
  loadDataAction: (keys, db) => dispatch(loadDataAction(keys, db)),
  setMapDataAction: (view, field) => dispatch(setMapDataAction(view, false, field, false))
});

export default connect(mapStateToProps, mapDispatchToProps)(Employment);
